import dJSON from 'dirty-json';

(() => {
  const moduleSelector = '.module-accordion';

  /**
 * Module Init
 */
  (() => {
    const modules = document.querySelectorAll(moduleSelector);
    if (!modules.length) return;

    modules.forEach((query) => {
      try {
        query.querySelector('script')?.remove(); // cleanup

        const { data } = dJSON.parse(query.data);

        data.forEach((item) => {
          query.querySelector('.js-accordion').insertAdjacentHTML('beforeend', /* html */ `
          <section class="accordion-tab" data-title="${item.title}">
            <h3 class="accordion-title" tabindex="0">${item.title}</h3>
            <div class="accordion-panel text-content">
              <div class="inner">
                <p>${item.text}</p>
              </div>
            </div>
          </section>
        `);
        });
      } catch (error) {
        console.error(`Error: ${moduleSelector}`, error);
      }
    });
  })();

  document.querySelectorAll('.js-accordion .accordion-title').forEach((item) => {
    const toggleAccordion = (e) => {
      // Close other accordions
      if (!e.classList.contains('nActive')) {
        e.closest('.js-accordion').querySelectorAll('.nActive').forEach((accordion) => {
          accordion.classList.remove('nActive');
        });
      }

      // toggle clicked accordion
      e.classList.toggle('nActive');
    };

    item.addEventListener('click', () => {
      toggleAccordion(item);
    });

    item.addEventListener('keyup', (e) => {
      if (!(e.key === 'Enter')) return;
      toggleAccordion(item);
    });
  });
})();
